import { render, staticRenderFns } from "./PageView.vue?vue&type=template&id=60e4547c&"
import script from "./PageView.vue?vue&type=script&lang=js&"
export * from "./PageView.vue?vue&type=script&lang=js&"
import style0 from "./PageView.vue?vue&type=style&index=0&id=60e4547c&lang=scss&"
import style1 from "./PageView.vue?vue&type=style&index=1&id=60e4547c&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60e4547c')) {
      api.createRecord('60e4547c', component.options)
    } else {
      api.reload('60e4547c', component.options)
    }
    module.hot.accept("./PageView.vue?vue&type=template&id=60e4547c&", function () {
      api.rerender('60e4547c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/contents/survey-paper-manage/PageView.vue"
export default component.exports